export default __webpack_public_path__ + "static/media/forgespirit.7e75c3f4.mpeg";